import { ActionButton } from "components";
import { Fragment } from "react";
import { PERMISION } from "security";

export function Delete(props: {
    approval_status: number,
    sales_order_id: number
}){
    return(
        <Fragment>
            {props.approval_status !== 4 && <ActionButton.Delete permission={PERMISION.SALES.REGISTER.BY_REFERENCE_ID.DELETE}  />}
        </Fragment>
    )
}